import { Button } from '@chakra-ui/button';
import React, { useGlobal } from 'reactn';
import { getImage } from "gatsby-plugin-image"
import { useLocation } from "@reach/router"
import { API } from '@aws-amplify/api';
import { v4 as uuidv4 } from 'uuid';

export function AddToCart({ globalState, variantSelected, searchHit, collection, itemLocation, searchObjectID, searchQueryID, productVariant,
  product, productMetafields, available, isDesign = false, isGarment = false, designGUID = null }) {

  const { store} = globalState

  const { scarves, scarfOrder, design } = store

  const [loading] = useGlobal('loading')
  const location = useLocation()
  const designRef = uuidv4();
  const designImage = isDesign && designGUID ? `https://scarforders-stage.s3.eu-west-1.amazonaws.com/${designGUID}/${designRef}/image.jpg` : ''

  const tagsList = product.tags.toString();
  const {
    price,
    on_sale,
    own_garment,
    sale_price
  } = productMetafields

  const variant = productVariant.title !== "Default Title" ? productVariant.title : null
  const actualSalePrice = on_sale && price > sale_price ? sale_price : price
  const options = product.options[0].values.join('|').replace('Default Title', '')
  const imgData = product.media[0] ? getImage(product.media[0].image).images.fallback.src : ""
  const custom2 = own_garment ? {
    name: "Shipping Information",
    value: "You will receive a separate eMail with details on how to send your garment to us."
  } :
    {
      name: null,
      value: null
    }

  async function callSnipcart(isDesign, isGarment, extraData ) {
    console.log("CALLING SNIPCART", isDesign, isGarment, extraData)
        var snipcartData = {
          id: product.handle,
          name: product.title,
          // price: price,
          price: actualSalePrice,
          alternatePrices: {
            saleprice: actualSalePrice
          },
          url: location.pathname,
          categories: product.tags,
          customFields: [        {
              name: "Size",
              value: variant,
              type: "dropdown",
              required: !own_garment,
              options: options
            }
          ],
          hasTaxesIncluded: true,
          taxable: true,
          image: isDesign ? extraData.imageLink : imgData,
          metadata: {
            ownGarment: own_garment,
            searchHit: searchHit,
            searchObjectID: searchObjectID,
            itemLocation: itemLocation,
            searchQueryID: searchQueryID,
            collection: collection
          },
          quantity: 1
        }
        if (own_garment) {
          snipcartData.customFields.push({
            name: custom2.name,
            value: custom2.value,
            type: "readonly"
          })          
        }
        if (isDesign) {
          // snipcartData.customFields.push({
          //   name: "Image Link",
          //   value: extraData.imageLink,
          //   type: "readonly"            
          // })          
          snipcartData.customFields.push({
            name: "Prompt",
            value: extraData.prompt,
            type: "readonly"            
          })
          if (isGarment) {
            console.log("ADD GARMENT FIELDS", extraData)
            snipcartData.customFields.push({
              name: "Design",
              value: extraData.designLink,
              type: "hidden"            
            })
            snipcartData.customFields.push({
              name: "Front",
              value: extraData.garmentLink1,
              type: "hidden "            
            })
            snipcartData.customFields.push({
              name: "Rear",
              value: extraData.garmentLink2,
              type: "hidden"            
            })
            snipcartData.customFields.push({
              name: "Arm",
              value: extraData.garmentLink3,
              type: "hidden"            
            }),
            snipcartData.customFields.push({
              name: "Design",
              value: extraData.designLink,
              type: "hidden"            
            })
          } else {
            snipcartData.customFields.push({
              name: "Front",
              value: extraData.scarfLinkFront,
              type: "hidden"            
            })
            snipcartData.customFields.push({
              name: "Rear",
              value: extraData.scarfLinkRear,
              type: "hidden"            
            })
            snipcartData.customFields.push({
              name: "Width",
              value: "18.5cm",
              type: "readonly"            
            })
            snipcartData.customFields.push({
              name: "Length",
              value: "167cm",
              type: "readonly"            
            })
          }
        }
        await Snipcart.api.cart.items.add(snipcartData);
      
  }

  async function addProduct(e) {
    try {
      if (isDesign) {
        function saveImage(scarfOrder, design, isGarment) {
          console.log("XXX - IS DESIGN", scarfOrder, isGarment)
          const data = {
            body: {
              prompt: scarfOrder.prompt,
              guid: design.guid,
              image: isGarment ? scarfOrder.garment1 : scarfOrder.image,
              scarfFront: scarfOrder.scarfFront,
              scarfRear: scarfOrder.scarfRear,
              garment1: scarfOrder.garment1,
              garment2: scarfOrder.garment2,
              garment3: scarfOrder.garment3,
              design: scarfOrder.design,
              isGarment: isGarment,
              ref: designRef
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
          console.log("DATA IS", data)
          return API.post('api', "/image/save", data)            
        }
        (async function () {
          console.log("CALLING")
          const response = await saveImage(scarfOrder, design, isGarment);
          console.log("RESPONSE", response)
          console.log("CALLING SNIP")
          await callSnipcart(isDesign, isGarment, response)
          console.log("DONE XXX")
        })();
      } else {
        await callSnipcart()
      }

      
    } catch (error) {
      console.log("ADD ERROR", error)
    }
  }
  console.log("IS DESdesignImageIGNXXX", isDesign, designImage)
  console.log("IS DESdesignImageIGNXXX", available, loading, variantSelected)
  return (
    <Button variant={"cart"} size={'cart'}
      type="submit"
      className='snipcart-add-itemxxx'
      onClick={addProduct}
      isDisabled={(isDesign && !designImage) || !available || loading || !variantSelected}
      id="snpbutton"
      data-item-id={product.handle}
      data-item-name={product.title}
      data-item-price={actualSalePrice}
      data-item-price-saleprice={actualSalePrice}
      data-item-url={location.pathname}
      data-item-custom1-value={productVariant.title}
      data-item-custom1-required={!own_garment}
      data-item-custom1-name="Size"
      data-item-custom1-options={product.productOptions}
      data-item-custom2-name={custom2.name}
      data-item-custom2-type="readonly"
      data-item-custom2-value={custom2.value}
      data-item-categories={tagsList}
      data-item-image={isDesign ? designImage : imgData}
    >
      {!available ? "Out of Stock" : variantSelected ? "Add to Cart" : "Select Size"}
    </Button>
  )
}
